<template>
  <section>
    <confirmation-modal
    :title="$t('Voltar da pausa')"
    :titleIcon="['play-circle-outline']"
    :cancelButtonText="$t('Cancelar')"
    :confirmButtonText="$t('Voltar da pausa')"
    @close-modal="v => handleConfirmPauseReturn(v)"
    :methodHandler="startPause"
    :canClose="true"
    v-if="isModalReturnPauseOpen"

    >
      <div class="content-modal-wrapper">
        <dot-loader v-if="isReturnFromPauseLoading" id="pause-loader">
        </dot-loader>
        <div class="content-modal-wrapper" v-else>
          <svg xmlns="http://www.w3.org/2000/svg" width="66" height="65" viewBox="0 0 66 65" fill="none">
            <path d="M57.625 32.5C57.625 19.043 46.707 8.12505 33.25 8.12505C19.793 8.12505 8.875 19.043 8.875 32.5C8.875 45.9571 19.793 56.875 33.25 56.875C46.707 56.875 57.625 45.9571 57.625 32.5Z" stroke="var(--darkBlue)" stroke-width="4" stroke-miterlimit="10"/>
            <path d="M28.2125 42.4582L42.7423 33.6807C42.9448 33.5573 43.1122 33.3839 43.2284 33.1771C43.3445 32.9704 43.4055 32.7372 43.4055 32.5C43.4055 32.2629 43.3445 32.0297 43.2284 31.8229C43.1122 31.6162 42.9448 31.4428 42.7423 31.3194L28.2125 22.5418C28.0043 22.4171 27.7666 22.3499 27.5238 22.3474C27.281 22.3448 27.0419 22.4068 26.831 22.5271C26.6202 22.6474 26.4451 22.8216 26.3238 23.0319C26.2024 23.2422 26.1392 23.481 26.1406 23.7238V41.2763C26.1392 41.5191 26.2024 41.7579 26.3238 41.9682C26.4451 42.1785 26.6202 42.3527 26.831 42.473C27.0419 42.5933 27.281 42.6553 27.5238 42.6527C27.7666 42.6501 28.0043 42.583 28.2125 42.4582Z" fill="var(--darkBlue)"/>
          </svg>
          <span v-if="!isReturnFromPauseLoading">{{$t("Deseja voltar da pausa:")}}</span>
          <span id="bold-font" v-if="dataPause.pauseName">{{ `${dataPause.pauseName} (${dataPause.totalPauseNecessary})` }}</span>

          <span>{{$t("Tempo total em pausa:")}}</span>
          <span id="bold-font" v-if="currentTimePaused">{{ currentTimePaused }}</span>
        </div>

      </div>
    </confirmation-modal>

    <confirmation-modal
      @close-modal="v => handleCloseModal(v)"
      v-if="isPauseModalOpened"
      :cancelButtonText="$t('Cancelar')"
      :confirmButtonText="$t('Confirmar pausa')"
      :titleIcon="['pause-circle-outline']"
      :title="$t('Marcar pausa')"
      :pauseMotives="pauseMotives"
      :methodHandler="startPause"
      :canClose="true"
    >
      <div class="content-modal-wrapper">
        <label v-if="!isPauseModalLoading" for="reason-pause" class="pause-label">{{$t("Selecione o motivo da pausa")}}<span>*</span></label>
        <select v-if="!isPauseModalLoading" name="pause" id="reason-pause" @change="onChange($event)">
          <option disabled selected></option>
          <option v-for="(pauseMotive, index) in pauseMotives" :value="pauseMotive.id" :key="index">
            {{ `${pauseMotive.motive}: ${pauseMotive.time} min`}}
          </option>
        </select>
        <dot-loader v-if="isPauseModalLoading" id="pause-loader"></dot-loader>
      </div>
    </confirmation-modal>

    <modal-change-password/>

    <modal-alert :actionLeftMenu.sync="actionEmit" :objAlert="alertMsg" />

    <modal-select-motive-to-pause :confirmPauseModal.sync="confirmPause" :callRequest="callRequest" />

    <modal-report-and-suggestion :msgToAlert.sync="anyMsg" :objRS="sendObjRS" />

    <nps-stage :msgToAlert.sync="anyMsg" />



    <!-- <div v-if="userInPause" class="background-pause">
      <div class="full-height">
        <div class="block-text">
          <div class="text">
            <img src="../../../assets/img/astronaut/astronaut-pause.png" alt="Marquiano pause">
            <span class="text-pause">Você está em <strong>pausa</strong> para</span>
            <span class="text-name">{{dataPause.pauseName}}</span>
            <span class="line-yellow"></span>
          </div>
          <div class="box-pause">
            <div v-if="dataPause.totalPauseNecessary !== '00:00'" class="box-default box-necessary">
              <div>
                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M31.5 18C31.5 10.5469 25.4531 4.5 18 4.5C10.5469 4.5 4.5 10.5469 4.5 18C4.5 25.4531 10.5469 31.5 18 31.5C25.4531 31.5 31.5 25.4531 31.5 18Z" stroke="white" stroke-width="2.25" stroke-miterlimit="10"/>
                  <path d="M14.625 13.5V22.5M21.375 13.5V22.5" stroke="#FDD944" stroke-width="2.25" stroke-miterlimit="10" stroke-linecap="round"/>
                </svg>
                <span class="box-title">Tempo de pausa:</span>
                <span class="box-name">{{ dataPause.totalPauseNecessary }}</span>
              </div>
            </div>
            <div class="box-default">
              <div>
                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7.93884 9.00004C5.75578 11.4382 4.53354 14.5869 4.49986 17.8594C4.41689 25.3371 10.5221 31.486 17.9999 31.5C25.467 31.5141 31.4999 25.4651 31.4999 18C31.4999 10.6496 25.6252 4.66808 18.3163 4.50004C18.2751 4.49871 18.2341 4.50569 18.1958 4.52055C18.1574 4.5354 18.1224 4.55784 18.0928 4.58651C18.0633 4.61519 18.0399 4.64952 18.0239 4.68745C18.0079 4.72538 17.9997 4.76614 17.9999 4.8073V10.6875" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M16.4098 19.5912L10.8551 11.6459C10.7783 11.5358 10.7426 11.4022 10.7544 11.2685C10.7662 11.1347 10.8247 11.0094 10.9196 10.9145C11.0146 10.8196 11.1399 10.7611 11.2736 10.7493C11.4073 10.7375 11.541 10.7731 11.651 10.85L19.5964 16.4047C20.0837 16.7557 20.4133 17.2844 20.5138 17.8765C20.6143 18.4686 20.4777 19.0765 20.1335 19.5687C19.7892 20.0608 19.2651 20.3977 18.6745 20.5064C18.0838 20.6151 17.4741 20.4869 16.9772 20.1495C16.7575 19.9973 16.5656 19.8084 16.4098 19.5912Z" fill="#FDD944"/>
                </svg>
                <span class="box-title">Tempo percorrido</span>
                <span v-if="!loadingPauseCount" class="box-name">{{ currentTimePaused }}</span>
                <span v-else class="box-name">
                  <div class="loading-btn">
                    <div class="spinner-btn">
                      <div class="rect1"></div>
                      <div class="rect2"></div>
                      <div class="rect3"></div>
                      <div class="rect4"></div>
                      <div class="rect5"></div>
                    </div>
                  </div>
                </span>
              </div>
            </div>
          </div>
          <button class="btn-pause" v-on:click="startPause()" :disabled="loadingPause">Voltar da pausa</button>
        </div>
      </div>
    </div> -->

    <div id="openNav"><button class="open-btn open-menu-xs visible-xs" v-on:click="openNav()">☰</button></div>
    <div id="mySidebar" class="sidebar custom-scrollbar" v-on:menus="updateMenus($event)">

      <a href="javascript:void(0)" class="close-btn visible-xs" v-on:click="closeNav()">×</a>

      <div class="logo">
        <router-link to="/">
          <img src="../../../assets/img/login/new-logo-login.png" v-if="!isDark && !logoImageUri && !companyPartner" class="new-logo" alt="Logo" />
          <img src="../../../assets/img/login/new-logo-white.png" v-if="isDark && !logoImageUri && !companyPartner" class="new-logo" alt="Logo" />

          <img v-if="companyPartner === 1"
            :src="'https://marqstorage.blob.core.windows.net/207a3b085aa64980a293d307d8804cdf/solicitations%2F046a8669-53ba-4237-9702-611815d9078b.png'"
            class="img-responsive"
            alt="logo"
            style="border-radius:30px; background-color: #63318A !important; width: 200px !important; max-height: 200px !important;"
            >
          <img v-if="logoImageUri && !companyPartner" :src="logoImageUri" class="img-responsive" alt="logo">
        </router-link>
      </div>

      <div class="left-menu-profile-wrapper" @click="redirectTo('perfil')">
      <div class="profile-wrapper">
        <!-- PROFILE IMG -->
        <img v-if="userInfo.photo" :src="userInfo.photo" class="profile-img-ellipse">
        <div v-else class="profile-img-ellipse">
          {{ getNameInitials(userInfo.name) }}
        </div>

        <!-- NAMES WRAPPER -->
        <div class="names-wrapper">
          <div class="name-left-menu" v-if="userInfo.name">
            {{ userInfo.name | limitTo(15) }}
          </div>

          <div class="job-left-menu" v-if="userInfo.office">
            {{ userInfo.office | limitTo(19) }}
          </div>
        </div>
      </div>


      <div class="first-stroke" />
      </div>



      <div class="point-pause-wrapper">
        <div class="left-menu-register-point-wrapper">
          <div
            class="left-menu-register-point"
            @click="redirectToRegisterPoint()"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none" class="register-point">
              <path class="register-point-svg" d="M3.21344 10.2578C3.07642 10.2591 2.94151 10.224 2.82242 10.1562C2.73507 10.1072 2.65838 10.0411 2.59686 9.96203C2.53533 9.88294 2.4902 9.79237 2.46409 9.69562C2.43799 9.59887 2.43145 9.49789 2.44484 9.39858C2.45824 9.29928 2.4913 9.20364 2.54211 9.11727C3.52117 7.48312 6.5 3.66895 13 3.66895C15.8168 3.66895 18.2873 4.40883 20.3394 5.86727C22.0284 7.06418 22.975 8.41902 23.4259 9.07156C23.4831 9.15381 23.5232 9.24668 23.544 9.34468C23.5648 9.44269 23.5657 9.54386 23.5468 9.64223C23.5279 9.74061 23.4894 9.83421 23.4338 9.91751C23.3782 10.0008 23.3064 10.0721 23.2228 10.1273C23.0519 10.2403 22.8437 10.2823 22.6423 10.2444C22.441 10.2064 22.2623 10.0916 22.1442 9.92418C21.3281 8.75062 18.8398 5.17969 13 5.17969C7.2998 5.17969 4.72265 8.46574 3.88324 9.87492C3.81579 9.9926 3.71815 10.0901 3.6004 10.1574C3.48265 10.2248 3.34906 10.2594 3.21344 10.2578Z"/>
              <path class="register-point-svg" d="M16.2749 25.1875C16.2101 25.1883 16.1454 25.1809 16.0824 25.1657C11.3674 23.9977 9.60679 19.2842 9.53519 19.0882L9.52402 19.045C9.48543 18.9089 8.53937 15.6767 9.99172 13.7836C10.6575 12.9203 11.67 12.4775 13.0071 12.4775C14.2502 12.4775 15.147 12.8639 15.7635 13.6637C16.2713 14.3168 16.4745 15.1221 16.671 15.8981C17.0838 17.5139 17.3819 18.3625 19.0978 18.4498C19.8514 18.4879 20.3465 18.0471 20.6273 17.6719C21.3865 16.6486 21.5186 14.9805 20.9462 13.5078C20.2109 11.6071 17.6013 8.02344 13 8.02344C11.0358 8.02344 9.23101 8.65465 7.78375 9.8409C6.58582 10.8235 5.63672 12.2109 5.17969 13.6368C4.33215 16.2916 5.44375 20.4648 5.45441 20.5029C5.48037 20.6001 5.48661 20.7014 5.47278 20.801C5.45895 20.9005 5.42532 20.9963 5.37387 21.0827C5.32242 21.1691 5.25421 21.2443 5.17324 21.3039C5.09227 21.3635 5.00018 21.4062 4.90242 21.4297C4.70491 21.4822 4.49469 21.4553 4.3168 21.3547C4.13892 21.254 4.00752 21.0877 3.95078 20.8914C3.9 20.701 2.71273 16.25 3.69179 13.1818C4.7582 9.85715 8.04933 6.50558 13.0015 6.50558C15.2902 6.50558 17.4525 7.28355 19.2573 8.75266C20.6548 9.89523 21.7963 11.4298 22.3935 12.9639C23.1527 14.9226 22.9491 17.1209 21.8761 18.557C21.1611 19.5147 20.1429 20.0154 19.015 19.9611C16.0768 19.8138 15.5487 17.7628 15.1638 16.2668C14.7677 14.7321 14.5143 13.9923 13.0015 13.9923C12.1707 13.9923 11.5873 14.2208 11.2242 14.6941C10.7291 15.3415 10.6905 16.3536 10.7453 17.0879C10.7813 17.5995 10.8681 18.1062 11.0043 18.6007C11.1252 18.9054 12.6989 22.7647 16.4679 23.6986C16.5653 23.7217 16.6571 23.7639 16.7381 23.8228C16.8191 23.8816 16.8875 23.956 16.9395 24.0416C16.9915 24.1272 17.0259 24.2222 17.0408 24.3212C17.0558 24.4202 17.0509 24.5212 17.0264 24.6182C16.9805 24.7821 16.8821 24.9265 16.7464 25.0293C16.6107 25.1321 16.4451 25.1876 16.2749 25.1875Z"/>
              <path class="register-point-svg" d="M10.2228 24.8391C10.1171 24.8394 10.0125 24.8183 9.91508 24.7772C9.81772 24.7361 9.72963 24.6758 9.65606 24.6C7.76903 22.6195 6.7016 20.4049 6.29992 17.6358V17.6211C6.07446 15.7879 6.40453 13.1925 8.02192 11.408C9.21578 10.0912 10.8941 9.42195 13.0015 9.42195C15.4939 9.42195 17.4525 10.5808 18.6738 12.7679C19.5599 14.3569 19.7356 15.9402 19.7402 16.0052C19.7495 16.1055 19.7389 16.2065 19.7091 16.3026C19.6793 16.3988 19.6308 16.4881 19.5664 16.5654C19.502 16.6428 19.423 16.7067 19.3339 16.7535C19.2447 16.8003 19.1473 16.829 19.047 16.838C18.8448 16.86 18.642 16.8015 18.4825 16.6753C18.323 16.549 18.2195 16.3651 18.1944 16.1632C18.0607 15.2131 17.7532 14.2958 17.2875 13.457C16.3409 11.7868 14.9007 10.9378 12.9959 10.9378C11.3506 10.9378 10.0633 11.4329 9.1777 12.4104C7.90106 13.8196 7.65426 15.9905 7.82946 17.4266C8.18137 19.8753 9.12235 21.8232 10.7839 23.564C10.8533 23.6362 10.9074 23.7215 10.9431 23.815C10.9788 23.9085 10.9953 24.0082 10.9917 24.1082C10.9881 24.2082 10.9645 24.3065 10.9221 24.3971C10.8798 24.4878 10.8197 24.569 10.7453 24.636C10.6021 24.7658 10.416 24.8381 10.2228 24.8391Z" />
              <path class="register-point-svg" d="M18.916 22.6576C17.2656 22.6576 15.8625 22.2005 14.7398 21.2921C12.4841 19.4746 12.2312 16.5146 12.22 16.3896C12.2041 16.1846 12.2703 15.9816 12.4041 15.8254C12.5378 15.6692 12.7282 15.5725 12.9332 15.5566C13.1383 15.5407 13.3412 15.6069 13.4975 15.7407C13.6537 15.8744 13.7504 16.0648 13.7663 16.2698C13.7719 16.3135 13.9973 18.7347 15.7361 20.1292C16.7649 20.9508 18.1401 21.2768 19.8346 21.0864C20.0372 21.0618 20.2412 21.1185 20.4021 21.2439C20.563 21.3693 20.6677 21.5533 20.6934 21.7557C20.7044 21.8557 20.6955 21.9569 20.6671 22.0534C20.6387 22.1499 20.5913 22.2397 20.5278 22.3177C20.4642 22.3957 20.3858 22.4603 20.2971 22.5076C20.2083 22.555 20.111 22.5842 20.0109 22.5936C19.6474 22.636 19.2819 22.6574 18.916 22.6576ZM20.2201 2.47762C19.5762 2.05867 17.293 0.8125 13 0.8125C8.49367 0.8125 6.20496 2.18918 5.69867 2.53906C5.66523 2.55959 5.63393 2.5834 5.60523 2.61016C5.60221 2.61309 5.59826 2.61488 5.59406 2.61523C5.51322 2.68582 5.44834 2.77283 5.40377 2.87047C5.3592 2.9681 5.33596 3.07412 5.33559 3.18145C5.33698 3.28205 5.3582 3.3814 5.39805 3.47378C5.4379 3.56617 5.49559 3.64979 5.56782 3.71984C5.64004 3.7899 5.72538 3.84501 5.81894 3.88202C5.9125 3.91904 6.01244 3.93723 6.11305 3.93555C6.2743 3.93544 6.43165 3.886 6.56398 3.79387C6.58582 3.77762 8.55562 2.33035 13.0015 2.33035C17.4474 2.33035 19.4279 3.77254 19.4492 3.7832C19.5844 3.88346 19.7486 3.93694 19.9169 3.93555C20.0176 3.93709 20.1176 3.91874 20.2112 3.88153C20.3048 3.84433 20.3901 3.78902 20.4622 3.71876C20.5343 3.64851 20.5919 3.5647 20.6316 3.47214C20.6712 3.37958 20.6922 3.28011 20.6934 3.17941C20.6934 3.02859 20.6484 2.88119 20.564 2.75614C20.4797 2.63109 20.3599 2.5341 20.2201 2.47762Z"/>
            </svg>
            <div class="register-point-text">
              {{$t("Marcar Ponto")}}
            </div>
          </div>
        </div>

        <div class="left-menu-register-pause-wrapper" v-if="menus && menus.pause && menus.pause.show">
          <div class="left-menu-register-pause" @click="openPauseModal" v-if="!userInPause">
            <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none" class="register-pause">
              <path class="register-pause-svg" d="M22.75 13C22.75 7.61719 18.3828 3.25 13 3.25C7.61719 3.25 3.25 7.61719 3.25 13C3.25 18.3828 7.61719 22.75 13 22.75C18.3828 22.75 22.75 18.3828 22.75 13Z" stroke="none" stroke-width="1.5" stroke-miterlimit="10"/>
              <path class="register-pause-svg" d="M10.5625 9.75V16.25M15.4375 9.75V16.25" stroke="none" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
            </svg>
            <div class="register-pause-text">
              {{$t("Marcar Pausa")}}
            </div>
          </div>

          <div v-else class="left-menu-paused" @click="openPauseModal">
            <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none" class="paused">
              <path class="paused-svg" d="M22.75 13C22.75 7.61719 18.3828 3.25 13 3.25C7.61719 3.25 3.25 7.61719 3.25 13C3.25 18.3828 7.61719 22.75 13 22.75C18.3828 22.75 22.75 18.3828 22.75 13Z" stroke="none" stroke-width="1.5" stroke-miterlimit="10"/>
              <path class="paused-svg" d="M10.5625 9.75V16.25M15.4375 9.75V16.25" stroke="none" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
            </svg>
            <div class="paused-text">
              {{$t("Em Pausa")}}
            </div>
          </div>
        </div>

        <div class="second-stroke" />
      </div>

      <div class="select-multiple-companies-wrapper" v-if="hasMultipleLogins">
        <ion-icon name="business-outline" id="business-outline"></ion-icon>
        <select id="select-multiple-companies" v-model="companySelected" @change="selectCompany(companySelected)">
          <option v-for="company in listAuth" :key="company.id" :value="company">{{ company.companyName | limitTo(18) }}</option>
        </select>
        <div class="select-stroke" />
      </div>

      <!-- <div v-if="hasMultipleLogins" class="content-list content-company-list">
        <p class="nunito">EMPRESA</p>

        <div class="select-company">
          <div class="view-actived" v-bind:title="companySelected.companyName">{{companySelected.companyName| limitTo(18)}} <i class="fa fa-angle-down" aria-hidden="true"></i>
            <div v-if="!c.current" v-on:click="selectCompany(c)" v-for="c in listAuth" class="list-options">
              <p v-bind:title="c.companyName">{{c.companyName | limitTo(18)}}</p>
            </div>
          </div>
        </div>
      </div> -->

      <div class="left-menu-general-features-wrapper">
        <left-menu-features
          :icon="'home-outline'"
          :title="$t('Início')"
          @click.native="redirectTo()"
          :style="{'color': activeMenu === 0 ? 'var(--darkBlue)' : ''}"
          >
        </left-menu-features>

        <left-menu-features
          :title="$t('Lembretes')"
          :icon="'document-text-outline'"
          is-new="true"
          @click.native="redirectToV2Function('pt', 'lembretes')"
          :style="{'color': activeMenu === 16 ? 'var(--darkBlue)' : ''}">
        </left-menu-features>

        <left-menu-features
          v-if="hasPDIAccess()"
          :customMaxWidth="'11ch'"
          :title="$t('PDI')"
          :icon="'accessibility-outline'"
          is-new="true"
          @click.native="redirectToV2Function('pt', 'pdi')"
          :style="{'color': activeMenu === 21 ? 'var(--darkBlue)' : ''}">
        </left-menu-features>

        <left-menu-features
          v-if="hasPerformanceAccess()"
          :customMaxWidth="'11ch'"
          :title="$t('Avaliação de Desempenho')"
          :icon="'ribbon-outline'"
          is-new="true"
          @click.native="redirectToV2Function('pt', 'performance-review')"
          :style="{'color': activeMenu === 20 ? 'var(--darkBlue)' : ''}">
        </left-menu-features>

        <left-menu-features
          v-if="hasNineBoxAccess()"
          :customMaxWidth="'11ch'"
          :title="$t('Matriz 9Box')"
          :icon="'apps-outline'"
          is-new="true"
          @click.native="redirectToV2Function('pt', 'ninebox')"
          :style="{'color': activeMenu === 21 ? 'var(--darkBlue)' : ''}">
        </left-menu-features>

<!--        <left-menu-features-->
<!--          :title="$t('Gestão de tarefas')"-->
<!--          :icon="'checkmark-done-circle-outline'"-->
<!--          is-new="true"-->
<!--          @click.native="redirectToV2Function('pt', 'task-management')"-->
<!--          :style="{'color': activeMenu === 18 ? 'var(&#45;&#45;darkBlue)' : ''}">-->
<!--        </left-menu-features>-->

        <left-menu-features
          :icon="'newspaper-outline'"
          :title="$t('Comunicados')"
          v-if="menus && menus.companyStatement && menus.companyStatement.show"
          :hasNotification="menus.companyStatement.hasNotification"
           @click.native="redirectToV2Function('pt', 'comunicados')"
          :style="{'color': activeMenu === 1 ? 'var(--darkBlue)' : ''}"
        >
        </left-menu-features>

        <left-menu-features
        :icon="'documents-outline'"
        :title="$t('Documentos')"
        v-if="menus && menus.document && menus.document.show"
        :hasNotification="menus.document.hasNotification"
        @click.native="redirectTo('documents')"
        :style="{'color': activeMenu === 2 ? 'var(--darkBlue)' : ''}"
        >
        </left-menu-features>

        <left-menu-features
        :icon="'star-outline'"
        :title="$t('Feedbacks')"
        v-if="menus && menus.feedback && menus.feedback.show"
        :hasNotification="menus.feedback.hasNotification"
        @click.native="locale > 0 ? redirectToV2Function('pt', 'feedbacks') : redirectTo('feedback')"
        :style="{'color': activeMenu === 3 ? 'var(--darkBlue)' : ''}"
        >
        </left-menu-features>

        <left-menu-features
          :title="$t('Reuniões 1:1')"
          :icon="'people-outline'"
          is-new="true"
          @click.native="redirectToV2Function('pt', 'reunioes')"
          :style="{'color': activeMenu === 17 ? 'var(--darkBlue)' : ''}">
        </left-menu-features>

        <left-menu-features
        :icon="'wallet-outline'"
        :title="$t('Reembolsos')"
        v-if="menus && menus.refund && menus.refund.show && locale === 0"
        :hasNotification="menus.refund.hasNotification"
        @click.native="redirectTo('reembolsos')"
        :style="{'color': activeMenu === 4 ? 'var(--darkBlue)' : ''}"
        >
        </left-menu-features>

        <left-menu-features
        :icon="'time-outline'"
        :title="$t('Saldo de horas')"
        v-if="menus && menus.balance && menus.balance.show"
        :hasNotification="menus.balance.hasNotification"
        @click.native="redirectTo('saldo-de-horas')"
        :style="{'color': activeMenu === 5 ? 'var(--darkBlue)' : ''}"
        >
        </left-menu-features>

        <left-menu-features
          :icon="'build-outline'"
          :title="$t('Solicitações de ajuste')"
          v-if="menus && menus.solicitation && menus.solicitation.show"
          :hasNotification="menus.solicitation.hasNotification"
          @click.native="redirectTo('minhas-solicitacoes')"
          :style="{'color': activeMenu === 6 ? 'var(--darkBlue)' : ''}"
          >
        </left-menu-features>

        <left-menu-features
        :icon="'airplane-outline'"
        :title="$t('Férias/Afastamento')"
        v-if="menus && menus.dayOff && menus.dayOff.show"
        :hasNotification="menus.dayOff.hasNotification"
        @click.native="redirectTo('lista-de-ferias-afastamento')"
        :style="{'color': activeMenu === 7 ? 'var(--darkBlue)' : ''}"
        >
        </left-menu-features>

        <left-menu-features
        :icon="'calendar-outline'"
        :title="$t('Histórico de Ponto')"
        @click.native="redirectTo('historico-de-ponto')"
        :style="{'color': activeMenu === 8 ? 'var(--darkBlue)' : ''}">
        </left-menu-features>

        <left-menu-features
        :icon="'clipboard-outline'"
        :title="$t('Espelhos de Ponto')"
        v-if="menus && menus.mirror && menus.mirror.show && locale === 0"
        :hasNotification="menus.mirror.hasNotification"
        @click.native="redirectTo('meus-espelhos')"
        :style="{'color': activeMenu === 9 ? 'var(--darkBlue)' : ''}"
        >
        </left-menu-features>

        <left-menu-features
          v-if="locale === 0"
          :icon="'code-slash-outline'"
          :title="$t('Log de Registros')"
          @click.native="redirectTo('historico-de-log')"
          :style="{'color': activeMenu === 10 ? 'var(--darkBlue)' : ''}">
        </left-menu-features>
      </div>



    <div class="left-menu-general-features-wrapper" v-if="menus && menus.manager && menus.manager.show">
      <left-menu-features
        v-if="role === 2 && locale === 0"
        :icon="'keypad-outline'"
        :title="$t('Modo ponto')"
        @click.native="redirectTo('registro-de-pontos')"
        :style="{'color': activeMenu === 11 ? 'var(--darkBlue)' : ''}"
      >

      </left-menu-features>

      <left-menu-features
        :icon="'people-outline'"
        :title="$t('Minha equipe')"
        @click.native="redirectToV2Function('pt', 'minha-equipe')"
        :style="{'color': activeMenu === 11 ? 'var(--darkBlue)' : ''}"
        >
      </left-menu-features>

      <left-menu-features
        :icon="'settings-outline'"
        :title="$t('Gestão de Ponto')"
        @click.native="permissions.find((e) => e.type === 98).access && accessToV2 ? redirectToV2Function('pt', 'planilha-horario') : redirectTo('gestao-de-ponto')"
        :style="{'color': activeMenu === 12 ? 'var(--darkBlue)' : ''}"
        >
      </left-menu-features>

      <left-menu-features
        :icon="'airplane-outline'"
        :title="$t('Gerenciar afastamentos')"
        id="airplane-rotate"
        @click.native="redirectToV2Function('pt', 'ferias')"
        :style="{'color': activeMenu === 13 ? 'var(--darkBlue)' : ''}"
      >
      </left-menu-features>

      <left-menu-features
        :icon="'receipt-outline'"
        :title="$t('Solicitações da equipe')"
        @click.native="permissions.find((e) => e.type === 97).access && accessToV2 ? redirectToV2Function('pt', 'adjustments') : redirectTo('solicitations-list')"
        :style="{'color': activeMenu === 14 ? 'var(--darkBlue)' : ''}"
      >
      </left-menu-features>

      <left-menu-features
      v-if="menus && menus.onCallDuty && menus.onCallDuty.show && locale === 0"
      :icon="'alarm-outline'"
      :title="$t('Sobreaviso')"
      @click.native="accessToV2 ? redirectToV2Function('pt', 'sobreaviso') : redirectTo('/')"
      :style="{'color': activeMenu === 15 ? 'var(--darkBlue)' : ''}"
      >
      </left-menu-features>
<!--
      <left-menu-features
      :icon="'folder-outline'"
      :title="$t('Gestão de documentos')"
      @click.native="accessToV2 ? redirectToV2Function('pt', 'documentos') : redirectTo('/')"
      :style="{'color': activeMenu === 15 ? 'var(--darkBlue)' : ''}"
      >
      </left-menu-features> -->

      <!-- <left-menu-features
      :icon="'chatbox-ellipses-outline'"
      :title="$t('Gestão de comunicados')"
      @click.native="accessToV2 ? redirectToV2Function('pt', 'statements') : redirectTo('/')"
      :style="{'color': activeMenu === 15 ? 'var(--darkBlue)' : ''}"
      >
      </left-menu-features> -->
    </div>

    <div class="left-menu-general-features-wrapper">
      <left-menu-features
        v-if="!isDark"
        :icon="'moon-outline'"
        :title="$t('Modo escuro')"
        @click.native="changeTheme"
      >
      </left-menu-features>

      <left-menu-features
        v-if="isDark"
        :icon="'sunny-outline'"
        :title="$t('Modo claro')"
        @click.native="changeTheme"
      >
      </left-menu-features>

      <left-menu-features
      :icon="'person-outline'"
      :title="$t('Meu perfil')"
      v-if="menus && menus.profile && menus.profile.show"
      @click.native="redirectTo('perfil')"
      :style="{'color': activeMenu === 15 ? 'var(--darkBlue)' : ''}"
      >
      </left-menu-features>

      <left-menu-features
        :icon="'megaphone-outline'"
        is-new="true"
        :title="$t('Ouvidoria')"
        @click.native="redirectToV2Function('pt', 'whistleblowing')"
        :style="{'color': activeMenu === 19 ? 'var(--darkBlue)' : ''}"
      >
      </left-menu-features>

      <left-menu-features
        v-if="locale && locale !== 0"
        :icon="'document-text-outline'"
        :title="$t('Termos de uso')"
        @click.native="redirectTo('termos-de-uso')"
        :style="{'color': activeMenu === 19 ? 'var(--darkBlue)' : ''}"
      >
      </left-menu-features>

      <left-menu-features
        v-if="locale && locale !== 0"
        :icon="'lock-closed-outline'"
        :title="$t('Política de privacidade')"
        @click.native="redirectTo('politica-de-privacidade')"
        :style="{'color': activeMenu === 19 ? 'var(--darkBlue)' : ''}"
      >
      </left-menu-features>

      <left-menu-features
      :icon="'log-out-outline'"
      :title="$t('Sair')"
      @click.native="logoutMenu()"
      >
      </left-menu-features>
    </div>
    </div>
  </section>
</template>

<script>
import { app } from '../../../main'
import modalChangePassword from "../modals/modalChangePassword.vue";
import modalSelectMotiveToPause from "../modals/modalSelectMotiveToPause.vue";
import modalAlert from "../modals/modalAlert.vue";
import npsStage from "./npsStage";
import ModalReportAndSuggestion from "../modals/modalReportAndSuggestion";
import LeftMenuFeatures from './leftMenuFeatures.vue';
import confirmationModal from './confirmationModal.vue';
import dotLoader from './dotLoader.vue'
import {REQUEST_SERVICE} from "../../../requestConfig";
import {UTIL_SERVICE} from "../../../utils";
import {
  CHECK_MENU,
  CHECK_PAUSE,
  IS_DEBUG,
  PAUSE_REGISTER_POINT,
  TIMER,
  USER_ACCESS,
  LEFT_MENU_FEATURES,
  PAUSE_MOTIVES,
  GET_MY_TEAM,
  ACCESS_TO_V2,
  SET_TOKEN,
} from "../../../urlConfig";

import moment from "moment";
import gsap from 'gsap';
import swal from "sweetalert";


export default {
    name:'left-menu',
    // props: ['obChangeTheme'],
    props: {
      openModalByHome: {
        type: Boolean
      },
    },
    components: {
      ModalReportAndSuggestion,
      npsStage,
      modalChangePassword,
      modalSelectMotiveToPause,
      modalAlert,
      LeftMenuFeatures,
      confirmationModal,
      dotLoader
    },
    data() {
      return {
        permissions: [],
        locale: null,
        accessToV2: false,
        logoImageUri: '',
        companyPartner: '',
        darkModeIcon: 'moon-outline',
        darkModeText: 'Modo escuro',
        managerData: {},
        myTeam: [],
        selectedCompany: '',
        isReturnFromPauseLoading: false,
        isPauseSent: false,
        isModalReturnPauseOpen: false,
        pauseData: {
          userInPause: false,
          pauseDate: '',
          pauseTitle: '',
          totalPauseTime: '',
          pausedTime: '',
          pauseDateText: ''
        },
        sendPauseBody: {},
        isPauseModalLoading: false,
        pauseMotives: [],
        isPauseModalOpened: false,
        hasMultipleLogins: false,
        loadingRequest: false,
        loadingPause: false,
        listAuth: [],
        companySelected: {},
        isDark: false,
        isDebug: IS_DEBUG,
        anyMsg: '',
        role: '',
        actionEmit: '',
        alertMsg: {},
        sendObjRS: {},
        activeMenu: null,
        showAllMenu: false,
        showMenuPause: false,
        showMenuRefund: false,
        showMenuDocs: false,
        showMenuFeedback: false,
        confirmPause: false,
        userInPause: false,
        dataPause: {},
        dataRegisterPause: {},
        callRequest: "",
        checkPauseStatus: null,
        intervalCurrentTimeNavBar: '',
        currentTimePaused: "",
        intervalCurrentPause: '',
        allTasks: '',
        loadingPauseCount: false,
        isManager: false,
        menus: {},
        userInfo: {},
        isAdmin: true,
        allMenus: {},
        modulePersonalDevelopment: false,
        pdiAccess: false,
      }
    },
    methods: {
      emitPermissions() {
        this.$emit('module-pd', this.modulePersonalDevelopment);
        this.$emit('pdi-access', this.pdiAccess)
      },
      getPermissionModulePersonalDevelopment() {
        const features = this.permissions;
        let access = false;

        for (let i = 0; i < features.length; i++) {
          if (features[i].type === 35) {
            if (features[i].access) {
              access = true;
              break;
            }
          }
          if (features[i].type === 39) {
            if (features[i].access) {
              access = true;
              break;
            }
          }
          if (features[i].type === 42) {
            if (features[i].access) {
              access = true;
              this.pdiAccess = true;
              break;
            }
          }
        }
        this.modulePersonalDevelopment = access;
        this.emitPermissions();
      },
      setTokenToV2(auth) {
        let authOld = auth;

        REQUEST_SERVICE.post(SET_TOKEN, {token: authOld.userToken}).then((response) => {
          authOld.token = response.data;
          UTIL_SERVICE.saveStorage('authUser', authOld);
        })
      },
      setAccessToV2() {
        REQUEST_SERVICE.get(ACCESS_TO_V2).then((response) => {
          UTIL_SERVICE.saveStorage('accessToV2', response.data.redirectToV2);
          UTIL_SERVICE.saveStorage('permissionDsr', response.data.enableDSR);
          UTIL_SERVICE.saveStorage('partner', response.data.companyPartner);
          this.companyPartner = response.data.companyPartner;
          this.accessToV2 = response.data.redirectToV2;
          this.permissions = response.data.permissions
          this.getPermissionModulePersonalDevelopment();
        })
      },
      redirectToV2Function(language, page) {
        UTIL_SERVICE.checkLocationAndRedirectToV2(language, page);
      },
      hasPerformanceAccess() {
        const found = this.permissions.find(e => e.type === 39);
        return found && found.access;
      },
      hasNineBoxAccess() {
        const found = this.permissions.find(e => e.type === 45)
        return found && found.access;
      },
      hasPDIAccess() {
        const found = this.permissions.find(e => e.type === 42);
        return found && found.access;
      },
      changeTheme() {
        this.isDark = !this.isDark
        UTIL_SERVICE.saveStorage('darkMode', {dark: this.isDark});

        let chooseTheme = UTIL_SERVICE.getStorage('darkMode');
        if (chooseTheme) {
          this.isDark = chooseTheme.dark;
        } else {
          this.isDark = false;
        }

        UTIL_SERVICE.setTheme();
      },
      emitManagerData() {
        const myTeam = UTIL_SERVICE.getStorage('myTeam');
        if(myTeam) {
          this.$emit('manager-data', myTeam)
        } else {
          this.$emit('manager-data', this.managerData)
        }
      },
      getMyTeams() {
        REQUEST_SERVICE.get(GET_MY_TEAM).then((response) => {
          UTIL_SERVICE.console('GET_MY_TEAMS', response.data)

          this.managerData.myTeam = response.data.users;
          this.emitManagerData();

          const myTeam = UTIL_SERVICE.getStorage('myTeam');
          if(!myTeam) {
            UTIL_SERVICE.saveStorage('myTeam', {
              myTeam: this.managerData.myTeam,
              isManager: this.menus.manager.show,
            })
          }
        })
      },
      handleConfirmPauseReturn(value) {
        if(value) {
          const doc = document.getElementsByClassName('background-pause')[0];
          if(doc) {
            doc.style.zIndex = '5';
          }
        } else {
          const doc = document.getElementsByClassName('background-pause')[0];
          if(doc) {
            doc.style.zIndex = '4';
          }
        }
        this.isModalReturnPauseOpen = value
      },
      emitUserInPause() {
        this.pauseData.userInPause = this.userInPause;
        this.pauseData.pauseTitle = this.dataPause.pauseName;
        this.pauseData.pausedTime = this.currentTimePaused;

        this.$emit('user-in-pause', this.pauseData)
      },
      onChange(event) {
        this.dataPause.pauseId = event.target.value
      },
      handleCloseModal(e) {
        const doc =  document.getElementsByClassName('background-pause')[0]

        if(doc) {
          doc.style.zIndex = '4';
        }

        this.isPauseModalOpened = e
      },
      openPauseModal() {
        if(this.userInPause) {
          document.getElementsByClassName('background-pause')[0].style.zIndex = '5';

          this.isModalReturnPauseOpen = true;
        } else {
          this.isPauseModalLoading = true;

          this.isPauseModalOpened = !this.isPauseModalOpened

          REQUEST_SERVICE.get(PAUSE_MOTIVES).then((response) => {
          UTIL_SERVICE.console('RESULT PAUSE_MOTIVES', response.data)

          this.isPauseModalLoading = false;
          this.pauseMotives = response.data
          this.selected = this.pauseMotives[0];
        }).catch((err) => {
          UTIL_SERVICE.console('ERROR PAUSE_MOTIVES', err)
        })
        }
      },
      getNameInitials (name) {
      const regex = /\b[A-Za-z]/g;
      const initials = (name.match(regex) || [])
          .map(initial => initial.toUpperCase()).slice(0, 2).join('');
      return initials;
    },
      redirectTo(route) {
        console.log('ROUTE:', route)
        if(!route) {
          this.$router.push('/')
        } else {
          this.$router.push(`/${route}`)
        }
      },
      redirectToAnnoucements() {
        this.$router.push('/comunicados')
      },
      getAllMenus() {
        const url = `${LEFT_MENU_FEATURES}?pageQtd=25&pageNumber=1`
        REQUEST_SERVICE.get(url).then((response) => {
          UTIL_SERVICE.console('RESULT LEFT_MENU_FEATURES', response.data);

          this.menus = response.data.menus;

          localStorage.setItem('menus', JSON.stringify(this.menus))

          localStorage.setItem('showChat', JSON.stringify(response.data.menus.chat));
          this.isManager = response.data.menus.manager.show;
          this.managerData.isManager = this.menus.manager.show;

        }).then(() => {
          const myTeam = UTIL_SERVICE.getStorage('myTeam');
          if(this.menus.manager.show && this.$route.path === '/' && !myTeam) {
            this.getMyTeams();
          } else {
            this.emitManagerData()
          }
        }).catch((reason) => {
          UTIL_SERVICE.console('ERROR LEFT_MENU_FEATURES', reason)
        })
      },
      updateMenus(updatedMenu) {
        this.allMenus = updatedMenu;
      },
      redirectToHome() {
          this.$router.push('/')
        },
      redirectToRegisterPoint() {
        this.$router.push('/registro-de-ponto')
      },
      getUserInfo() {
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
      },
      selectCompany(company) {
        this.companySelected = company;

        window.localStorage.removeItem("userProfile");
        window.localStorage.removeItem("dateLastPointConfirm");
        window.localStorage.removeItem("homeCtrl");
        window.localStorage.removeItem("configProgressPoint");
        window.localStorage.removeItem("solicitationCtrl");
        window.localStorage.removeItem("historyListPoints");
        window.localStorage.removeItem("pointHistoryCtrl");
        window.localStorage.removeItem("myOccurrenceCtrl");
        window.localStorage.removeItem("myRequestsCtrl");
        window.localStorage.removeItem("mirrorCtrl");
        window.localStorage.removeItem("hourBalanceCtrl");
        window.localStorage.removeItem("showFeelings");
        window.localStorage.removeItem("dataConfirmPoint");
        window.localStorage.removeItem("hourBalance");
        window.localStorage.removeItem("logoWebUri");
        window.localStorage.removeItem("3hours");
        window.localStorage.removeItem("configMenu");
        window.localStorage.removeItem('myTeam');

        try {
          window.sessionStorage.removeItem("identifier");
          this.logoImageUri = '';
        } catch(e) {
          console.log(e)
        }

        // Change data atuh
        const authObject = {
          isAuth: true,
          userContentSetting: company.contextCode,
          userToken: company.token,
          userTokenType: "bearer"
        };
        window.localStorage.setItem('authUser', JSON.stringify(authObject));

        // Change data user
        const dataUserJson = JSON.parse(window.localStorage.getItem('userInfo'));
        dataUserJson.admissionDate = company.admissionDate;
        dataUserJson.code = company.code;
        dataUserJson.email = company.email;
        dataUserJson.userName = company.email;
        dataUserJson.photo = company.photo;
        dataUserJson.office = company.office;
        dataUserJson.role = company.role;
        dataUserJson.id = company.userId;
        dataUserJson.company.isUsingPause = company.company.isUsingPause;
        dataUserJson.company.id = company.companyId;
        dataUserJson.company.name = company.companyName;
        dataUserJson.companyId = company.companyId;

        this.role = company.role;

        if (company.name) {
          dataUserJson.name = company.name;
        }

        dataUserJson.auths.map((value, index) => {
          value.current = value.companyName === company.companyName;
        });

        window.localStorage.setItem('userInfo', JSON.stringify(dataUserJson));
        this.getMyTeams();

        setTimeout(() => {
          if (window.location.pathname === "/") {
            window.location.reload();
          } else {
            this.$router.push({path: '/'});
          }
        }, 500);
      },
      openReportAndSug(type) {
        this.sendObjRS = {type: type, random: Math.floor(Math.random() * 500)};

        $("#modalReportAndSuggestion").modal();
      },
      openNav() {
        window.localStorage.setItem('showMenuOpen', JSON.stringify({show: true}));

        document.getElementById("mySidebar").style.width = "250px";
        document.getElementById("mySidebar").style.zIndex = "3";

        document.getElementById("mainContent").style.marginLeft = "250px";
        document.getElementById("mainContent").style.position = "fixed";

        document.getElementById("openNav").style.position = "fixed";
        document.getElementById("openNav").style.height = "100%";
        document.getElementById("openNav").style.width = "100%";
        // document.getElementById("openNav").style.zIndex = "2";
        // document.getElementById("openNav").style.background = "rgba(0, 0, 0, 0.33)";

        try {
          document.getElementById("vueFooter").style.marginLeft= "250px";
        } catch (e) {}

        try {
          document.getElementById("contentBack").style.marginLeft= "250px";
        } catch (e) {}
      },
      closeNav() {
        window.localStorage.setItem('showMenuOpen', JSON.stringify({show: false}));

        document.getElementById("mySidebar").style.width = "0";

        document.getElementById("mainContent").style.marginLeft= "0";
        document.getElementById("mainContent").style.position = "relative";

        document.getElementById("openNav").style.position = "initial";
        document.getElementById("openNav").style.height = "auto";
        document.getElementById("openNav").style.width = "auto";
        document.getElementById("openNav").style.zIndex = "2";
        document.getElementById("openNav").style.background = "transparent";

        try {
          document.getElementById("vueFooter").style.marginLeft= "0";
        } catch (e) {}

        try {
          document.getElementById("contentBack").style.marginLeft= "0";
        } catch (e) {}
      },
      sendIdentifier() {
        try {
          if ($('#identifier').attr('class')) {
            let browserInfo = UTIL_SERVICE.checkBrowser();
            let url = USER_ACCESS;
            const { dark } = JSON.parse(window.localStorage.getItem('darkMode'))

            url += "?deviceModel=" + browserInfo.name;
            url += "&i=" + JSON.parse(window.localStorage.getItem('userInfo')).id;
            url += "&version=" + browserInfo.version;
            url += "&deviceId=" + this.browserId;
            url += "&pushToken=" + $('#identifier').attr('class');
            if(dark === true) {
              url += "&themeMode=" + "2"
            } else {
              url += "&themeMode=" + "1"
            }

            UTIL_SERVICE.console("URL Send:", url);

            REQUEST_SERVICE.get(url).then((response) => {
              UTIL_SERVICE.console("RESULT USER_ACCESS:", response.data);


              let historyListChatCtrl = UTIL_SERVICE.getStorage('historyListChat');
              historyListChatCtrl.showChat = response.data.showChat;
              this.logoImageUri = response.data.logoWebUri;

              UTIL_SERVICE.saveStorage('historyListChat', historyListChatCtrl);
              UTIL_SERVICE.saveStorage('logoWebUri', {logoWebUri: response.data.logoWebUri});

              window.localStorage.setItem('userAccess', JSON.stringify(response.data));
            }).catch(reason => {

            });
          }
        } catch (e) {
        }
      },
      updateTimePaused() {
        this.datePause.setSeconds(this.datePause.getSeconds() + 1);

        const hours = moment(this.datePause).hours();
        const minutes = moment(this.datePause).minutes();
        const seconds = moment(this.datePause).seconds();

        const totalSeconds = this.convertHoursAndMinutesToSeconds(hours, minutes, seconds)

        this.pauseData.totalPauseTime = this.dataPause.totalPauseNecessary + ':00';

        const [maxHours, maxMinutes] = this.pauseData.totalPauseTime.split(':');

        if(!maxHours === '00') {
          this.pauseData.pausedTimePercentage = this.calculateWorkedHoursPercentage(totalSeconds, maxHours)
        } else {
          this.pauseData.pausedTimePercentage = this.calculatePausedMinutesPercentage(totalSeconds, maxMinutes)
        }
        // console.log(this.pauseData.pausedTimePercentage)

        this.currentTimePaused = moment(this.datePause, "YYYYMMDD HH:mm").format('HH:mm:ss');
        this.emitUserInPause()
      },
      convertHoursAndMinutesToSeconds(hours, minutes, seconds) {
        if(!hours) {
          hours = 0;
        }

        if(!minutes) {
          minutes = 0;
        }

        if(!seconds) {
          seconds = 0;
        }

        return Number(hours * 3600) + Number(minutes * 60) + Number(seconds);
      },
      calculateWorkedHoursPercentage(seconds, maxWorkHours) {
        const maxSeconds = this.convertHoursAndMinutesToSeconds(null, Number(maxWorkHours), null)

        const percentage = (seconds / maxSeconds) * 100;
        if(percentage <= 100) {
          return percentage
        } else {
          return 100
        }
      },
      calculatePausedMinutesPercentage(seconds, maxPauseMinutes) {
        const maxSeconds = this.convertMinutesToSeconds(maxPauseMinutes);

        const percentage = (seconds / maxSeconds) * 100;

        if(percentage <= 100) {
          return percentage
        } else {
          return 100
        }

        return percentage;
      },
      convertMinutesToSeconds(minutes) {
        return minutes * 60;
      },
      checkStatusPause() {
        this.loadingPauseCount = true

        REQUEST_SERVICE.get(CHECK_PAUSE).then((response) => {
          UTIL_SERVICE.console("RESULT CHECK_PAUSE:", response.data);

          if (response.data.showInfo) {
            this.userInPause = true;
            this.dataPause = response.data.pause;
            this.currentTimePaused = response.data.pause.totalInPause;

            this.pauseData.pauseDate = this.dataPause.pauseMotive.createdAt;
            const pauseDateText = JSON.parse(localStorage.getItem('pauseDateText'));
            this.pauseData.pauseDateText = pauseDateText;
            let convertDate = moment(new Date()).format("YYYY-MM-DD") + "T" + response.data.pause.totalInPause;
            this.datePause = new Date(convertDate);

            this.intervalCurrentPause = setInterval(() => this.updateTimePaused(), 1000);
          } else {
            clearInterval(this.intervalCurrentPause);
          }

          this.loadingPauseCount = false
        }).catch((reason) => {
          UTIL_SERVICE.console('ERROR CHECK_PAUSE', reason)
          this.loadingPauseCount = true
        });
      },
      checkTeam() {
        let url = CHECK_MENU;
        url += "?firstFromDay=true";

        UTIL_SERVICE.console("CHECK MENU:", url);
        REQUEST_SERVICE.get(url).then((response) => {
          UTIL_SERVICE.console("RESULT CHECK_MENU:", response.data);

          window.localStorage.setItem('configMenu', JSON.stringify(response.data));

          this.showAllMenu = response.data;
        }).catch((error) => {
          UTIL_SERVICE.console('RESULT CHECK_MENU', error)
        });
      },
      changePassword: function () {
        $("#modalChangePassword").modal();
      },
      logoutMenu: function () {
        REQUEST_SERVICE.logout().then((response) => {
          window.localStorage.removeItem("dateLastPointConfirm");
          window.localStorage.removeItem("logoWebUri");
          window.localStorage.removeItem("homeCtrl");
          window.localStorage.removeItem("myTeam");
          window.localStorage.removeItem("configProgressPoint");
          window.localStorage.removeItem("solicitationCtrl");
          window.localStorage.removeItem("historyListPoints");
          window.localStorage.removeItem("pointHistoryCtrl");
          window.localStorage.removeItem("myOccurrenceCtrl");
          window.localStorage.removeItem("myRequestsCtrl");
          window.localStorage.removeItem("mirrorCtrl");
          window.localStorage.removeItem("hourBalanceCtrl");
          window.localStorage.removeItem("showFeelings");
          window.localStorage.removeItem("dataConfirmPoint");
          window.localStorage.removeItem("userProfile");
          window.localStorage.removeItem("hourBalance");
          window.localStorage.removeItem("3hours");
          window.localStorage.removeItem("authUser");
          window.localStorage.removeItem("configMenu");
          window.localStorage.removeItem("menus");

          UTIL_SERVICE.historyLog(false, window.location.pathname, 'logoutMenu', null, false, null);
          UTIL_SERVICE.setTheme();

          if (this.companyPartner === 1) {
            this.$router.push({ path: '/villafacil' });
          } else {
            this.$router.push({ path: '/login' });
          }
        });
      },
      updateCurrentTimeNavBar() {
        this.currentDateTimeNavBar.setSeconds(this.currentDateTimeNavBar.getSeconds() + 1);
      },
      getTimerNavBar() {
        this.loadingRequest = true;
        REQUEST_SERVICE.get(TIMER).then((response) => {
          UTIL_SERVICE.console("RESULT TIMER:", response.data);

          this.currentDateTimeNavBar = new Date(response.data);
          this.intervalCurrentTimeNavBar = setInterval(() => this.updateCurrentTimeNavBar(), 1000);

          this.loadingRequest = false;
        }).catch(reason => {
          this.loadingRequest = false;
        });
      },
      startPause: function () {
        if(window.screen.width < 500) {

          this.closeNav()
        }
        clearInterval(this.intervalCurrentTimeNavBar);
        this.isPauseModalLoading = true;

        if(!this.isPauseSent) {
          this.getTimerNavBar();

          if (this.userInPause) {
            this.isReturnFromPauseLoading = true;
            this.sendRequestPause();
          } else {
            this.sendRequestPause();
            this.isReturnFromPauseLoading = false;
          }
        }
      },
      sendRequestPause() {
        this.loadingPause = true

        // Get Browser Info
        try {
          let browserInfo = UTIL_SERVICE.checkBrowser();
          this.dataRegisterPause.deviceModel = browserInfo.name;
          this.dataRegisterPause.version = browserInfo.version;
          } catch (err) {
        }

        this.dataRegisterPause.deviceType = "3";
        this.dataRegisterPause.dt = moment(this.currentDateTimeNavBar, "YYYYMMDD HH:mm").format('YYYY-MM-DD HH:mm:ss');
        this.dataRegisterPause.deviceId = JSON.parse(window.localStorage.getItem('browserId'));
        this.dataRegisterPause.companyPauseMotiveId = this.dataPause.pauseId;

        if(!this.isPauseSent) {
          UTIL_SERVICE.console("DATA SEND:", this.dataRegisterPause);
          REQUEST_SERVICE.post(PAUSE_REGISTER_POINT, this.dataRegisterPause).then((response) => {
            UTIL_SERVICE.console("RESULT PAUSE_REGISTER_POINT:", response.data);
            const pauseDateText = `${moment(response.data.date, "YYYYMMDD HH:mm").format('DD/MM/YYYY')} às ${moment(response.data.date, "YYYYMMDD HH:mm").format('HH:mm')}`

            localStorage.setItem('pauseDateText', JSON.stringify(pauseDateText));

            this.pauseData.pauseDateText = pauseDateText;

            this.userInPause = !this.userInPause;

            this.pauseData.pauseDate = response.data.date;

            if (this.userInPause) {
              this.isPauseModalOpened = false;
              this.isReturnFromPauseLoading = false
              this.checkStatusPause();
            } else {
              this.dataPause = {};
              clearInterval(this.intervalCurrentPause);
            }

            this.emitUserInPause();
            this.redirectTo()

            if(this.userInPause) {
              this.$toast.success("Pausa iniciada.", {
                timeout: 3000,
                closeOnClick: false,
                pauseOnFocusLoss: false,
                pauseOnHover: false,
                closeButton: 'button',
                position: 'top-center'
              });
            } else {
              this.isModalReturnPauseOpen = false;
              document.getElementsByClassName('background-pause')[0].style.zIndex = '4';
              this.isReturnFromPauseLoading = false;
              this.$toast.success("Pausa finalizada.", {
                timeout: 3000,
                closeOnClick: false,
                pauseOnFocusLoss: false,
                pauseOnHover: false,
                closeButton: 'button',
                position: 'top-center'
              });
            }
            this.isPauseSent = false;
            this.loadingPause = false

            UTIL_SERVICE.historyLog(false, window.location.pathname, 'sendRequestPause', null, false, null);
            }).catch(reason => {
              UTIL_SERVICE.historyLog(false, window.location.pathname, 'sendRequestPause', this.dataRegisterPause, true, reason.response.data);
              this.isPauseModalOpened = true;
              this.isPauseModalLoading = false;
              this.isPauseSent = false;

              console.log('REASON SEND REQUEST PAUSE', reason.response.data)

               reason.response.data.erros.map((err) =>{
                this.$toast.error(err.value, {
                  timeout: 20000,
                  closeOnClick: false,
                  pauseOnFocusLoss: true,
                  pauseOnHover: true,
                  closeButton: 'button',
                  position: 'top-center'
                  });
               })
            });
          this.isPauseSent = true;
          }
      },
      checkTimeDiffPause() {
        const currentTime = moment();
        const pausedTime = moment(this.currentTimePaused, 'HH:mm:ss');
        const timeDifference = moment.duration(currentTime.diff(pausedTime));
        const hours = Math.floor(timeDifference.asHours()).toString().padStart(2, '0');
        const minutes = timeDifference.minutes().toString().padStart(2, '0');
        const seconds = timeDifference.seconds().toString().padStart(2, '0');
        const pauseDuration = `${hours}:${minutes}:${seconds}`;

        const initialTime = moment(pauseDuration, 'HH:mm:ss');
        const currentPausedTime = moment(this.currentTimePaused, 'HH:mm:ss');

        const combinedTime = initialTime.add({
          hours: currentPausedTime.hours(),
          minutes: currentPausedTime.minutes(),
          seconds: currentPausedTime.seconds()
        });

        const resultingTime = combinedTime.format('HH:mm:ss');
        const momentResultingTime = moment(resultingTime, 'HH:mm:ss');

        const minuteDifference = momentResultingTime.diff(currentTime, 'minutes');
        return minuteDifference > 1;
      },
      handleVisibilityChange() {
        if (!document.hidden) {
          if(this.userInPause) {
            clearInterval(this.intervalCurrentPause);
            this.checkStatusPause();
          }
        }
      }
    },
    beforeMount() {
      this.getUserInfo();
      this.setAccessToV2();

      const menus = UTIL_SERVICE.getStorage('menus');
      // this.getAllMenus();
      if(!menus) {
        this.getAllMenus();
      } else {
        this.menus = menus;
      }

      const myTeam = UTIL_SERVICE.getStorage('myTeam');

      if(myTeam) {
        this.emitManagerData()
      }

      // Show footer
      try {$("#vueFooter").removeClass("d-none");} catch(e){}

      try {
        this.$route.params.userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
      } catch (e){}

      // Set theme color
      UTIL_SERVICE.setTheme();
      try {
        let chooseTheme = JSON.parse(window.localStorage.getItem('darkMode'));
        if (chooseTheme) {
          this.isDark = JSON.parse(window.localStorage.getItem('darkMode')).dark;
        }
      } catch (e) {}

      const logoWebUri = JSON.parse(window.localStorage.getItem('logoWebUri'));

      if (logoWebUri) {
        if (logoWebUri.logoWebUri) {
          this.logoImageUri = logoWebUri.logoWebUri;
        }
      }

      // Has multiples company
      try {
        const dataUserJson = JSON.parse(window.localStorage.getItem('userInfo'));
        if (dataUserJson.hasMultipleLogins) {
          this.hasMultipleLogins = dataUserJson.hasMultipleLogins;
          this.listAuth = dataUserJson.auths;

          this.listAuth.map((value, index) => {
              if (value.current) {
                this.companySelected = value;
              }
          });
        }
      } catch (e) {}

      // Check Pause
      try {
        this.showMenuPause = JSON.parse(window.localStorage.getItem('userInfo')).company.isUsingPause;
        if (this.showMenuPause) {
          this.checkStatusPause();
        }
      } catch (e) {
        console.error(e)
      }

      try {
        this.showMenuRefund = JSON.parse(window.localStorage.getItem('userInfo')).company.refund;
        this.showMenuDocs = JSON.parse(window.localStorage.getItem('userInfo')).company.document;
        this.showMenuFeedback = JSON.parse(window.localStorage.getItem('userInfo')).company.feedback;
      } catch (e) {
        console.error(e)
      }

      // Set Role
      this.role = JSON.parse(window.localStorage.getItem('userInfo')).role;

      // Set locale

      this.locale = JSON.parse(window.localStorage.getItem('userInfo')).company.locale;

      // Set BrowserID
      this.browserId = JSON.parse(window.localStorage.getItem('browserId'));

      if (this.browserId === null) {
        this.browserId = UTIL_SERVICE.randomToken();
        window.localStorage.setItem('browserId', JSON.stringify(this.browserId));
      }

      // Checks whether you are in point mode
      let mode = JSON.parse(window.localStorage.getItem('modePin'));
      if (mode) {
        if (mode.onlyPin === true) {
          if (this.pathName !== "/registro-de-pontos") {
            this.$router.push({path: '/registro-de-pontos'});
          }
        }
      }

      // Check First request of the day
      let checkFirstRequestDay = {date: ''};

      // if (JSON.parse(window.localStorage.getItem('configMenu')))
        this.showAllMenu = JSON.parse(window.localStorage.getItem('configMenu'));

      if (JSON.parse(window.localStorage.getItem('checkFirstRequestDay')))
        checkFirstRequestDay = JSON.parse(window.localStorage.getItem('checkFirstRequestDay'));

      if (checkFirstRequestDay.date !== moment(new Date()).format('DD/MM/YYYY')) {
        window.localStorage.setItem('checkFirstRequestDay', JSON.stringify({date: moment(new Date()).format('DD/MM/YYYY')}));

        this.checkTeam();
      } else if (!this.showAllMenu) {
        this.checkTeam();
      }

      // Set icon is active on menu by pathname
      switch (window.location.pathname) {
        case '/':
          this.activeMenu = 0;
          break;
        case '/statements':
          this.activeMenu = 1;
          break;
        case '/documents':
        this.activeMenu = 2;
        break;
        case '/feedback':
          this.activeMenu = 3;
          break;
        case '/refund':
          this.activeMenu = 4;
          break;
        case '/balance-hours':
          this.activeMenu = 5;
          break;
        case '/my-solicitations':
          this.activeMenu = 6;
          break;
        case '/vacation':
          this.activeMenu = 7;
          break;
        case '/clock-in-history':
          this.activeMenu = 8;
          break;
        case '/timecard-mirrors':
          this.activeMenu = 9;
          break;
          case '/log-history':
          this.activeMenu = 10;
          break;
        case '/my-team':
          this.activeMenu = 11;
          break;
        case '/clock-in-management':
          this.activeMenu = 12;
          break;
        case '/manage-vacations':
          this.activeMenu = 13
          break;
        case '/solicitations-list':
          this.activeMenu = 14;
          break;
        case '/profile':
          this.activeMenu = 15;
          break;
        case '/reminders':
          this.activeMenu = 16;
          break;
        case '/meetings':
          this.activeMenu = 17;
          break;
        case '/task-management':
          this.activeMenu = 18;
          break;
        case '/whistleblowing':
          this.activeMenu = 19;
          break;
        case '/performance-review':
          this.activeMenu = 20;
        case '/pdi':
          this.activeMenu = 21;
      }
    },
    beforeDestroy() {
      // document.removeEventListener("visibilitychange", this.handleVisibilityChange);
    },
    created() {
      // Check and send Identifier
      setTimeout(()=> {
        if (!sessionStorage.identifier) {
          sessionStorage.identifier = true;
          this.sendIdentifier();
        }
      }, 2000);

      // Config initial to responsive
      if (window.innerWidth <= 600) {
        let menuIsOpen = JSON.parse(window.localStorage.getItem('showMenuOpen')).show;

        setTimeout(()=> {
          if (menuIsOpen) {
            document.getElementById("mySidebar").style.zIndex = "3";

            document.getElementById("mainContent").style.marginLeft = "250px";
            document.getElementById("mainContent").style.position = "fixed";

            document.getElementById("openNav").style.position = "fixed";
            document.getElementById("openNav").style.height = "100%";
            document.getElementById("openNav").style.width = "100%";
            document.getElementById("openNav").style.zIndex = "2";
            // document.getElementById("openNav").style.background = "rgba(0, 0, 0, 0.33)";
          } else {
            this.closeNav();
          }
        }, 100);
      }
    },
    watch: {
      menus(newValue, oldValue) {
        this.$emit('menus', newValue);
      },
      managerData(newValue, oldValue) {
        this.$emit('manager-data', newValue);
      },
      openModalByHome() {
        // document.getElementsByClassName('background-pause')[0].style.zIndex = '5';
        this.handleConfirmPauseReturn(true)
      },
      showAllMenu: function (newValue, oldValue) {
        this.$route.params.menus = newValue;
      },
      showMenuFeatures: function(newValue) {
        this.$route.params.menuFeatures = newValue;
      },
      obChangeTheme: function (val) {
       this.isDark = val;
      },
      actionEmit: function(response) {
        UTIL_SERVICE.console("ACTION EMIT: ", response);
        if (response) {
          if (response.value) {
            if (response.value === "callSendRequestPause") {
              this.sendRequestPause();
            }
          }
        }
      },
      confirmPause: function (value) {
        if (value) {
          if (value.id) {
            this.dataPause.pauseId = value.id;
            this.dataPause.pauseName = value.motive;
            this.dataPause.totalPauseNecessary = value.time;

            this.pauseData.pauseTitle = value.motive;
            this.pauseData.totalPauseTime = this.dataPause.totalPauseNecessary;
            this.sendRequestPause();
          }
        }
      },
      anyMsg: function (value) {
        this.alertMsg = {text: value, isSuccess: true, width: '350px'};

        $("#modalAlert").modal();
      },
    },
    mounted() {
      setTimeout(()=> {
        const authUser = UTIL_SERVICE.getStorage('authUser');

        if (!authUser.token) {
          this.setTokenToV2(authUser);
        }
      }, 5000);
      // document.addEventListener("visibilitychange", this.handleVisibilityChange);

      // setInterval(() => {
      //   if(this.checkTimeDiffPause()) {
      //     clearInterval(this.intervalCurrentPause);
      //     this.checkStatusPause();
      //   }
      // }, 5000);
     },
  }
</script>

<style lang="scss">
  .logo {
    .new-logo {
      width: 90px !important;
    }
  }

  #mySideBar {
    .left-menu-profile-photo {
      height: 50px !important;
      background: black;
    }
  }

  .left-menu-general-features-wrapper {
    border-bottom: 2px solid #EBEBEB;
    padding-bottom: 15px;
  }

  .left-menu-general-features-wrapper:last-child {
    border-bottom: none;
  }

  .content-modal-wrapper {
    position: relative;
    min-height: 36px;
    display: flex;
    flex-direction: column;
    gap: 5px;
    align-items: center;

    .content-modal-pause-reason {
      border-bottom: 2px solid #E2E2E2;
      padding-bottom: 15px;
      margin-bottom: 10px;
      width: 261px;
    }

    #pause-loader {
      position: absolute;
      margin: 0 !important;
      left: -123px !important;
    }

    #return-pause-icon {
      height: 65px;
      width: 65px;
      margin-bottom: 10px;
    }

    #bold-font {
      font-weight: 600;
      text-align: center;
    }
  }

  .content-company-list {
    .select-company {
      position: relative;

      .view-actived {
        border: 1px solid var(--linkColor);
        color: var(--linkColor) !important;
        display: block;
        margin: 0 auto;
        width: 80%;
        border-radius: 32px;
        height: 29px;
        padding: 4px 8px 4px 12px;
        background: transparent !important;
        position: relative;
        cursor: pointer;

        i {
          color: var(--linkColor) !important;
          position: absolute;
          top: 4px;
          right: 14px;
          font-size: 22px;
        }

        .list-options {
          cursor: pointer;
          border: 1px solid var(--linkColor);
          display: none;
          margin: 0 auto 0;
          width: 112%;
          border-radius: 32px;
          height: 29px;
          padding: 4px 8px 4px 12px;
          background: var(--bodyContrast) !important;
          position: relative;
          left: -12px;

          p {
            margin: 0;
            color: var(--linkColor) !important;
          }

          &:first-of-type {
            margin-top: 2px;
          }
        }

        &:hover {
          .list-options {
            display: block !important;
          }
        }
      }
    }
    select {
      border: 1px solid var(--linkColor);
      color: var(--linkColor) !important;
      display: block;
      margin: 0 auto;
      width: 80%;
      border-radius: 32px;
      height: 29px;
      padding: 4px 8px 4px 12px;
      background: transparent !important;
    }
  }

  .open-menu-xs {
    background: #352DA5;
    color: #fff;
    border: none;
    position: relative;
    width: 40px;
    height: 32px;
    font-size: 19px;
    border-bottom-right-radius: 5px;
  }

  .background-pause {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    background: rgba(255,255,255, 0.5);
    width: 100%;
    text-align: center;
    position: fixed;
    z-index: 8;
    bottom: 0;
    top: 0;
    right: 0;
    left: 0;
    overflow: auto;

    .block-text {
      margin-top: 96px;
      padding-bottom: 30px;

      @media screen and (max-width: 580px) {
        margin-top: 0;
      }

      .text {
        display: flex;
        flex-direction: column;
        align-items: center;

        .text-pause {
          margin-top: 30px;
          font-size: 28px;
          font-weight: 700;
          line-height: 39.38px;
          color: #FFFFFF;
          text-shadow: 2px 2px 10px rgba(0, 0, 0, 0.25);

          strong {
            color: #FDD944;
          }
        }

        .text-name {
          line-height: 39.38px;
          font-size: 28px;
          font-weight: 400;
          color: #FFFFFF;
          text-shadow: 2px 2px 10px rgba(0, 0, 0, 0.25);
        }

        .line-yellow {
          margin-top: 16px;
          width: 78px;
          height: 8px;
          box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.25);
          background: #FDD944;
        }
      }

      .box-pause {
        display: flex;
        flex-direction: row;
        justify-content: center;
        margin-top: 32px;
        margin-bottom: 38px;

        @media screen and (max-width: 580px) {
          flex-direction: column;
          margin-right: 30px;
          margin-left: 30px;
        }

        .box-necessary {
          margin-right: 32px;

          @media only screen and (max-width: 580px) {
            margin-right: 0;
            margin-bottom: 32px;
          }
        }

        .box-default {
          background: rgba(255, 255, 255, 0.15);
          border: 1px solid #EEEEEE;
          padding: 15px 30px;
          border-radius: 15px;
          backdrop-filter: blur(2.5px);

          div {
            display: flex;
            flex-direction: column;
            align-items: center;

            .box-title {
              font-size: 21px;
              font-weight: 400;
              color: #FFFFFF;
              line-height: 29.53px;
            }

            .box-name {
              font-size: 21px;
              font-weight: 700;
              color: #FDD944;
              line-height: 29.53px;
              min-width: 100px;

              .loading-btn {
                .spinner-btn {
                  margin-top: 6px;
                  height: 20px;
                  text-align: center;
                  flex-direction: row !important;
                  justify-content: center;
                  width: 100%;

                  > div {
                    margin-right: 8px;
                    background-color: #FDD944 !important;
                    width: 5px;
                    height: 20px;
                  }
                }
              }
            }
          }
        }
      }

      .btn-pause {
        background: transparent;
        border: 1px solid #FDD944;
        padding: 8px 30px;
        font-size: 14px;
        font-weight: 400;
        line-height: 19.69px;
        color: #FDD944;
        border-radius: 4px;
        cursor: pointer;
        transition: .2s;
        width: max-content;
        margin: 0 auto 30px auto;
        position: relative;
        min-width: 170.44px;
        min-height: 37.69px;
        height: max-content;

        &:hover {
          background: rgba(253, 217, 68, 0.15);
        }

        &:disabled {
          cursor: no-drop;
        }
      }
    }

    p {
      text-align: center;
      color: #fff;
      font-weight: 500;
      font-size: 38px;
      display: inline-block;
      padding: 0 50px;
      width: 600px;

      span {
        display: block;
      }

      &:first-child {
        display: block;
        text-align: center;
        margin-bottom: 30px;
        width: 100%;
      }
    }

    button {
      display: block;
      border: none;
      margin: 30px auto 0;
      height: 52px;
      width: 350px;
      border-radius: 4px;
      text-align: center;
      font-weight: 500;
      font-size: 17px;
      letter-spacing: 1px;
      text-transform: uppercase;
      color: #fff;
      background: #FFAB2D;
    }

    .full-height {
      height: 100%;
    }
  }

  .relative {
    position: relative !important;
  }

  .new {
    min-height: 21px;
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 10px;
    text-align: center;
    top: 0;
    color: #FFFFFF;
    background: var(--linkColor);
    border-radius: 39px;
    padding: 4px 6px;
    position: absolute;
    width: 40px !important;
    left: 100px;
    max-width: 40px !important;
    min-width: 40px !important;
  }

  .sidebar {
    height: 100%;
    width: 250px;
    position: fixed;
    direction: none !important;
    top: 0;
    left: 0;
    background-color: var(--leftMenuColor);

    transition: 0.5s;
    padding-top: 30px;
    box-shadow: 5px 5px 5px 0 rgba(0, 0, 0, 0.06);

    .left-menu-profile-photo {
      height: 50px !important;
      background: black;

      .profile-img-ellipse {
        object-fit: cover;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 30px;
        height: 30px;
        border-radius: 30px;
        border: 1px solid #fff;
        background: #d9d9d9;
        color: #FFF;
        font-size: 15.875px;
        font-weight: 500;
        box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, 0.1);
      }
    }
  }

  .sidebar::-webkit-scrollbar {
    display: none;
  }

  .swal-text {
    text-align: center;
  }

  .have-alert {
    a {
      display: flex !important;
      align-items: center !important;
      gap: 15px !important;
    }

    ion-icon {
      pointer-events: none;
    }
  }
  .request-pending {
    font-size: 20px;
    color: var(--yellowColor);
    visibility: visible;
  }

</style>



// WEBPACK FOOTER //
// src/vue/views/components/leftMenu.vue